const SHIPMENT_TYPE = require("@dpdgroupuk/mydpd-enums").SHIPMENT_TYPE;
const { REGEX, COUNTRY_CODE } = require("../constants");
const { Joi } = require("../joi");

exports.empty = ["", null];

exports.string35Length = () => Joi.string().max(35);

exports.organisation = () => exports.string35Length().example("Team London");

exports.contactName = () => exports.string35Length().example("Abraam");

exports.street = () => exports.string35Length().example("Addle Street");

exports.postcode = () =>
  Joi.string()
    .max(8)
    .when("countryCode", {
      is: COUNTRY_CODE.GREAT_BRITAIN,
      then: Joi.string()
        .regex(REGEX.GB_POSTCODE_PATTERN)
        .required(),
    })
    .when("countryCode", {
      is: COUNTRY_CODE.IRELAND,
      then: Joi.string()
        .regex(REGEX.IE_POSTCODE_PATTERN)
        .allow(exports.empty),
      otherwise: Joi.string().allow(exports.empty),
    })
    .example("NW3 6AN");

exports.countryCode = () =>
  Joi.string()
    .max(2)
    .regex(REGEX.COUNTRY_CODE)
    .example("GB");

exports.locality = () => exports.string35Length().example("Belsize Park");

exports.town = () => exports.string35Length().example("London");

exports.vatNumber = () =>
  Joi.string()
    .max(45)
    .example("999900001");

exports.county = () => exports.string35Length().example("County");

exports.phoneNumber = () =>
  Joi.string()
    .max(15)
    .regex(REGEX.PHONE_PATTERN)
    .example("+4402012341234");

exports.email = () =>
  Joi.string()
    .max(100)
    .regex(REGEX.EMAIL_PATTERN)
    .example("example@dpdgroup.co.uk");

exports.shippingRef = () =>
  Joi.string()
    .max(25)
    .allow(exports.empty)
    .example("reference");

exports.deliveryInstructions = () =>
  Joi.string()
    .max(50)
    .example("some instruction");

exports.networkCode = () =>
  Joi.string()
    .max(255)
    .example("1^07");

exports.date = () =>
  Joi.date()
    .iso()
    .example("2021-07-13");

exports.numberOfParcels = () =>
  Joi.number()
    .integer()
    .min(1)
    .max(99)
    .example(1);

exports.businessUnit = () =>
  Joi.number()
    .integer()
    .min(1)
    .max(2)
    .example(1);

exports.allowUnknownParams = params => Joi.object(params).unknown();

exports.totalWeight = () =>
  Joi.number()
    .min(0.1)
    .max(99999)
    .example(5);

exports.shipmentType = () => Joi.number().example(SHIPMENT_TYPE.DOMESTIC);

exports.profileCode = () =>
  Joi.string()
    .max(10)
    .example("1000012");

exports.generateCustomsData = () => Joi.boolean().example(false);

exports.customsValue = () =>
  Joi.number()
    .greater(0)
    .max(99999999.99)
    .precision(2)
    .example("333.3");

exports.parcelDescription = () =>
  Joi.string()
    .max(45)
    .allow(exports.empty);

exports.exportReason = () =>
  Joi.string()
    .max(45)
    .example("01");

exports.customsNumber = () => Joi.string().example("FDA REG NO");

exports.eoriNumber = ({ max = 30 } = {}) =>
  Joi.string()
    .max(max)
    .example("GB1245");

exports.ukimsNumber = ({ length = 32 } = {}) =>
  Joi.string()
    .length(length)
    .example("11111111111111111111111111111111");

exports.invoiceAtRisk = () => Joi.boolean().example(false);

exports.currency = () =>
  Joi.string()
    .length(3)
    .example("GBP");

exports.deliveryDescription = (maxLength = 30) =>
  Joi.string()
    .max(maxLength)
    .example("Description");

exports.destinationTaxId = () =>
  Joi.string()
    .max(45)
    .optional();

exports.gstVatPaid = () => Joi.boolean().example(false);

exports.liabilityValue = () =>
  Joi.number()
    .min(0.01)
    .max(5000)
    .example(333);

exports.dropAtShop = (def = null, allow = null) =>
  Joi.boolean()
    .allow(allow)
    .example(null);
